import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAppDispatch } from "core/hooks/useAppDispatch";
// import momentTz from "moment-timezone";
import {
  fetchListCommentRequest,
  reloadListCommentRequest,
  createCommentRequest,
  deleteCommentRequest,
  reportCommentRequest,
} from "../store/actions";

export const uniqueArrayBy = (arr: any[], key: string = 'id') => {
  return arr.filter((v,i,a)=>a.findIndex(t=>(t[key] === v[key]))===i);
}

export const useGetCommentList = (post_id: any) => {
  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();
  const { loading, data, hasMore, params } = useSelector(
    (state: any) => state.Community.comments || {}
  );
  const post = useSelector((state: any) => state.Community.detail?.data);

  const fetchData = (_params: any) => {
    dispatch(fetchListCommentRequest({...params, ..._params}));
  };

  useEffect(() => {
    if (+post?.id !== +post_id) {
      dispatch(fetchListCommentRequest({
        ...params,
        post_id,
        last_id: null,
        // latest_timestamp: momentTz.tz('Etc/UTC').format('YYYY-MM-DD HH:mm:ss'),
      }));
    } else {
      appDispatch(fetchListCommentRequest({
        ...params,
        post_id,
        last_id: null,
        // latest_timestamp: momentTz.tz('Etc/UTC').format('YYYY-MM-DD HH:mm:ss'),
      }));
    }
  }, [post_id]);

  const reLoadList = (cb: (state: boolean) => void, id?: number) => {
    dispatch(reloadListCommentRequest({
      ...params,
      last_id: null,
      limit: data.length,
      callback: (data: any) => {
        const newState = (data || []).find((e: any) => e.id === id)?.user_reaction;
        return cb?.(newState);
      }
    }));
  }

  const loadMore = useCallback(() => {
    if (loading) {
      return;
    }
    const lastItem = data[data.length - 1];
    const last_id = lastItem?.id;
    if (last_id) {
      fetchData({
        ...params,
        last_id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, params, data]);

  return {
    loading,
    data,
    reLoadList,
    loadMore,
    hasMore,
    params,
  };
};

export const useCreateComment = (id: string | number | undefined, tab?: string) => {
  const dispatch = useDispatch();
  const [text, setText] = useState("");

  const { loadingForm: loading } = useSelector(
    (state: any) => state.Community.comments || {}
  );

  useEffect(() => {
    if (!loading) {
      setText("");
    }
  }, [loading])

  const createComment = (content: string) => {
    if (id) {
      dispatch(createCommentRequest({id: String(id), content, tab}));
    }
  };

  return {
    createComment,
    loading,
    text,
    setText,
  };
};

export const useDeleteComment = () => {
  const dispatch = useDispatch();

  const deleteComment = (post_id: string | number, comment_id: string | number) => {
    dispatch(deleteCommentRequest({
      post_id: String(post_id),
      comment_id: String(comment_id)
    }));
  };

  return {
    deleteComment,
  };
};

export const useReportComment = () => {
  const dispatch = useDispatch();

  const reportComment = (post_id: string | number, comment_id: string | number) => {
    dispatch(reportCommentRequest({
      post_id: String(post_id),
      comment_id: String(comment_id)
    }));
  };

  return {
    reportComment,
  };
};
